import * as types from '../actions/actionTypes';
import initialState from './initialState';
import { GFGroups } from '../models/models';

export default function groupReducer(
  state: GFGroups = initialState.groups,
  action: any
): GFGroups {
  switch (action.type) {
    case types.LOAD_TEACHERS_SUCCESS:
      return { ...state, members: action.teachers };
    default:
      return state;
  }
}
